module.exports = __webpack_public_path__ + "img/fan.afb8e640.svg";